export const iconFontAwesomeArrowsMaximize = (
	<i className="fa-solid fa-maximize"></i>
);
